import React from 'react'
import { Outlet } from 'react-router-dom'

import { ErrorPageNavbar, Footer } from 'components'

export const ExceptionLayout: React.FC = () => {
  return (
    <>
      <ErrorPageNavbar />
      <Outlet />
      <Footer className="-mt-l" layout="public" />
    </>
  )
}
